export default "__VITE_ASSET__BblntGfo__"